import { memo } from "react";
import Flx from "../../../../components/layout/Flx";
import { InfoOutlined } from "@mui/icons-material";

const ColumnDefHeaderLabelWithIcon = memo((props) => {
  const { displayName } = props;

  return (
    <Flx ac gap={0.2} sx={{ width: "100%" }}>
      <span>{displayName}</span>
      <InfoOutlined
        sx={{
          fontSize: 14,
          color: "inherit",
          cursor: "pointer",
        }}
      />
    </Flx>
  );
});

export default ColumnDefHeaderLabelWithIcon;
